export function formatDateToDDMMYY(dateString) {
  if (!dateString) return '';
  const dateObj = new Date(dateString);
  if (Number.isNaN(dateObj)) return '';
  
const hasTimezone = /([TZ]|[+-]\d{2}:?\d{2})$/.test(dateString);  
  if (hasTimezone) {    
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const year = String(dateObj.getUTCFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  } else {
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = String(dateObj.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  }
}